import {Component} from '@angular/core';
import {SistemaService} from '@servicios/Sistema.Service';

@Component(
    {
        selector: 'contenido',
        templateUrl: './contenido.template.html',
        styleUrls: ['./contenido.scss'],
    })

export class ContenidoComponent {
    public menuAbierto: boolean;
    public menuEstatico: boolean;

    constructor(private sistemaService: SistemaService) {
        this.menuAbierto = false;
        this.menuEstatico = localStorage.getItem(this.sistemaService.localStoreVariable.SideBarFijo) == "1";
    }

    ngOnInit() {
    }

    CambiarMenuEstatico(val: boolean) {
        this.menuEstatico = val;
    }

    CambiarMenuAbierto(val: boolean) {
        this.menuAbierto = val;
    }
}
